export default "__VITE_ASSET__40bce6aa__"